export enum Role {
  admin = 'admin',
  member = 'member',
  user = 'user'
}
